import React, { useEffect, Suspense } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams, Link, Route, Routes, Navigate } from 'react-router-dom'
import { GetScheduleSyncUser } from '../../../store/ScheduleSync/ScheduleSyncUserAction';
import * as Tab from '../../../util/TabValue';
import RenderTabs from '../../misc/Tabs';
import ScheduleSyncUserObjectLogs from './ScheduleSyncUserObjectLogs';
import { ScheduleSync_CoreUser } from '../../../models/CoreScheduleSyncModels';
import { RequestState } from '../../../models/RequestState';
import StatusCode from '../../../util/StatusCode';
import { useTranslation } from 'react-i18next';
import NotFound from '../../administration/components/NotFound';
import Loading from '../../misc/Loading';
import ScheduleSyncUserInfo from './ScheduleSyncUserInfo';
import ScheduleSyncUserTrackings from './ScheduleSyncUserTrackings';
import ScheduleSyncUserSchedule from './ScheduleSyncUserSchedule';
import { RootState } from '../../../store/store';



const ScheduleSyncUser = () => {
    const { t } = useTranslation(['common', 'scheduleSync']);

    const { userId } = useParams();
    const dispatch = useDispatch();
    const user = useSelector<RootState, RequestState<ScheduleSync_CoreUser>>(state => state.schedulesync_users.user);

    useEffect(() => {
        if (userId) {
            GetScheduleSyncUser(userId)(dispatch);
        }
    }, [dispatch, userId]);

    const tabs = [
        Tab.Tabs.Information,
        Tab.Tabs.ObjectLogs,
        Tab.Tabs.Schedule,
        Tab.Tabs.Trackings,
    ];

    if (userId === undefined) {
        return;
    }

    const renderContent = (body: any) => (
        <div className="padding-40 container single">
            <h1><Link to="/schedulesync/user">{t('object.scheduleSync.user', { ns: 'common', count: 1 })}</Link>{displayName}</h1>
            {body}
        </div>
    )

    let displayName: string | undefined = '';

    switch (user.code) {
        case StatusCode.COMPLETE:
            displayName = user.data.displayName;
            return (renderContent(<>
                <RenderTabs
                    tabs={tabs}
                    id={userId}
                    url="schedulesync/user" />

                <Suspense>
                    <Routes>
                        <Route path={Tab.Tabs.Information.url} element={<ScheduleSyncUserInfo />} />
                        <Route path={Tab.Tabs.ObjectLogs.url} element={<ScheduleSyncUserObjectLogs />} />
                        <Route path={Tab.Tabs.Schedule.url} element={<ScheduleSyncUserSchedule />} />
                        <Route path={Tab.Tabs.Trackings.url} element={<ScheduleSyncUserTrackings />} />
                        <Route path="*" element={<Navigate replace={true} to={`/schedulesync/user/${userId}/${Tab.Tabs.Information.url}`} />} />
                    </Routes>
                </Suspense>
            </>));
        case StatusCode.ERROR:
            if (user.error.response?.status === 404 || user.error.response?.status === 400) {
                return (
                    <NotFound
                        header={t('object.scheduleSync.user', { ns: 'common', count: 1 })}
                        translateKey={{ i18nKey: "notFound.user", ns: "scheduleSync" }}
                        link="/schedulesync/user"
                    />
                );
            } else {
                return renderContent(<p>{user.error.response?.statusText}</p>);
            }
        default:
            return (renderContent(<Loading />));
    }
}

export default ScheduleSyncUser;
